module.exports = __webpack_public_path__ + "static/media/34.9a4a2e42.mp3";